module.exports = Em.Handlebars.compile("{{view.value}}\n");